module.exports = __webpack_public_path__ + "img/frame (254).e93b6709.jpg";